import styles from './Header.module.css'

const Header = () => {
  return (
    <div className={styles.header}>
      <h2 className={styles.title}>User Accounts</h2>
    </div>
  )
}

export default Header
